import { motion } from "motion/react";
import { useMemo } from "react";

import styled from "styled-components";

import { useGetUserData } from "Flocknote/API/queries";

import { useAccountAndSettingsRef } from "NavBar/navBarStore";
import {
  useEffectiveBgManagerHeight,
  useIsFullScreen,
} from "NavBar/stateHooks";
import {
  accountAndSettingsBottomPadding,
  springAnimation,
} from "NavBar/styleConstants";

import FnrOpacityToggle from "UI/FnrOpacityToggle";

import useHasFinePointer from "Utilities/Hooks/useHasFinePointer";

import DashboardButton from "./DashboardButton";
import HelpButton from "./HelpButton";
import HoverText from "./HoverText";
import ImportManagerCollapse from "./ImportManagerCollapse";
import LogoutButton from "./LogoutButton";
import SettingsButton from "./SettingsButton";
import UserButton from "./UserButton";

const AccountAndSettings = () => {
  const accountAndSettingsRef = useAccountAndSettingsRef();
  const { isFetched } = useGetUserData();
  const effectiveBgManagerHeight = useEffectiveBgManagerHeight();
  const isFullScreen = useIsFullScreen();
  const hasFinePointer = useHasFinePointer();

  const animate = useMemo(() => {
    const paddingBottom =
      effectiveBgManagerHeight +
      (isFullScreen ? 0 : accountAndSettingsBottomPadding);

    return {
      padding: `0 ${isFullScreen ? 0 : 8}px ${paddingBottom}px ${
        isFullScreen ? 0 : 8
      }px`,
      transition: springAnimation,
    };
  }, [effectiveBgManagerHeight, isFullScreen]);

  return (
    <motion.div animate={animate}>
      <SFnrOpacityToggle
        show={isFetched}
        data-cy="NavBar_GroupCommunicationMenu"
        ref={accountAndSettingsRef}
        delayIn={1000}
      >
        <UserButton />
        <RightButtonsContainer>
          {hasFinePointer && <HoverText />}
          <RightButtons>
            <ImportManagerCollapse />
            <DashboardButton />
            <SettingsButton />
            <HelpButton />
            <LogoutButton />
          </RightButtons>
        </RightButtonsContainer>
      </SFnrOpacityToggle>
    </motion.div>
  );
};

const RightButtonsContainer = styled.div`
  position: relative;
`;

const RightButtons = styled.div`
  display: flex;
  gap: 4px;
`;

const SFnrOpacityToggle = styled(FnrOpacityToggle)`
  padding-top: 12px; // this container is used to calculate the height of the active section, and we want padding top to be part of the calculation.
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default AccountAndSettings;
